import { ViewHeaderDescription } from '@msdk/definitions'

import { UrlContext } from '../state/url-context'

const URL_CONTEXT_KEY = 'vhd'

type CompressedViewHeaderDescription = {
  d: string // description
  t: string // tDescription
  i: string // idml
}

function compressViewHeaderDescription(viewHeaderDescription: ViewHeaderDescription): CompressedViewHeaderDescription {
  return {
    d: viewHeaderDescription.description,
    t: viewHeaderDescription.tDescription,
    i: viewHeaderDescription.idml,
  }
}

function expandViewHeaderDescription(
  compressedViewHeaderDescription: CompressedViewHeaderDescription,
): ViewHeaderDescription {
  return {
    description: compressedViewHeaderDescription.d,
    tDescription: compressedViewHeaderDescription.t,
    idml: compressedViewHeaderDescription.i,
  }
}

function serializeViewHeaderDescription(viewHeaderDescription: ViewHeaderDescription): string {
  return JSON.stringify(compressViewHeaderDescription(viewHeaderDescription))
}

function deserializeViewHeaderDescription(vhd: string): ViewHeaderDescription {
  return expandViewHeaderDescription(JSON.parse(vhd) as CompressedViewHeaderDescription)
}

export function createContextWithViewHeaderDescription(
  viewHeaderDescription?: ViewHeaderDescription,
): Record<string, string> | undefined {
  if (!viewHeaderDescription) {
    return undefined
  }

  return {
    [URL_CONTEXT_KEY]: serializeViewHeaderDescription(viewHeaderDescription),
  }
}

export function enancheUrlContextWithViewHeaderDescription(
  urlContext: UrlContext,
  viewHeaderDescription?: ViewHeaderDescription,
): UrlContext {
  return {
    ...urlContext,
    [URL_CONTEXT_KEY]: viewHeaderDescription ? serializeViewHeaderDescription(viewHeaderDescription) : undefined,
  }
}

export function getViewHeaderDescriptionFromContext(urlContext: UrlContext): ViewHeaderDescription | undefined {
  const { vhd } = urlContext
  if (!vhd) {
    return undefined
  }

  try {
    return deserializeViewHeaderDescription(vhd)
  } catch (e) {
    return undefined
  }
}

export function getTranslatedViewHeaderDescription(
  viewHeaderDescriptionObj: ViewHeaderDescription | undefined,
  t: (idml: string, description: string) => string,
) {
  return viewHeaderDescriptionObj
    ? t(viewHeaderDescriptionObj.idml, viewHeaderDescriptionObj.tDescription || viewHeaderDescriptionObj.description)
    : undefined
}
